import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../utils/axiosInstance";

export const useProfile = () =>
  useQuery({
    queryKey: ["user-action-data"],
    queryFn: async () => {
      try {
        const res = await axiosInstance.get("/api/v1/user");
        return res.data.data;
      } catch (error) {
        console.error("Error fetching User Info:", error);
        throw error;
      }
    },
    refetchOnWindowFocus: true,
    refetchInterval: 5 * 60 * 1000, // 5 minutes
    staleTime: 5 * 60 * 1000,
  });
